import Vue from 'vue';
import router from '../router'
export default {
    state:{
      examenes:{
        avance_total:0,
        mostrar_tiempo_restante:false,
        tiempo_restante:14400,
        tiempo_restante_horas:'',
      }
    },
    mutations: {
      setAvance_Total(state,avance_total){
        state.examenes.avance_total=avance_total;
      },
      setTiempo_Restante(state,tiempo_restante){
        state.examenes.tiempo_restante=tiempo_restante;
        state.examenes.tiempo_restante_horas=moment.utc(tiempo_restante*1000).format('HH : mm : ss');
      },
      setMostrar_Tiempo_Restante(state,value){
        state.examenes.mostrar_tiempo_restante=value;
      },
    },
    actions: {
      Actualizar_Tiempo_Restante(context,tiempo){
        Vue.http.post('solicitudes/actualizar/tiempo/restante',{
          tiempo_restante:tiempo
        })
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          if (respuestaJson.resp=='Excelente') {
            
          }else{
              
          }
        })
        .catch(error=>{
          
        });
      },
      Iniciar_Tiempo_Restante(context,tiempo_restante){
        context.commit('setTiempo_Restante',tiempo_restante);
        console.log('Iniciar_Tiempo_Restante');
        $(document).ready(function(){
          clearInterval();
          var x = setInterval(function() {
            context.commit(
              'setTiempo_Restante',
              context.state.examenes.tiempo_restante-1
            );
            if (context.state.examenes.tiempo_restante==0) {
              clearInterval(x);
              context.dispatch('Actualizar_Tiempo_Restante',0);
              router.push({name:'Presentar'});
              swal("El tiempo se terminó", "La prueba tiene un tiempo de 4 horas máximo", "error");
            }
          },1050);
        });
      },
      Mostrar_Tiempo_Restante(context,value){
        context.commit('setMostrar_Tiempo_Restante',value);
      }
    },
    getters: { 
      getAvance_Total(state){
        return state.examenes.avance_total;
      },
      getMostrar_Tiempo_Restante(state){
        return state.examenes.mostrar_tiempo_restante;
      },
      getTiempo_Restante(state){
        return state.examenes.tiempo_restante;
      },
      getTiempo_Restante_Horas(state){
        return state.examenes.tiempo_restante_horas;
      },
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/examenes.js